import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
/* Layout */
import Layout from '@/layout'
const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login.vue')
  },
  {
    path: '',
    component: Layout,
    redirect: '/index',
    children:[{
      path: '/index',
      name: 'index',
      component: () => import('@/views/index.vue')
    }]
  },
  {
    path: '/details',
    component: Layout,
    redirect: '/details',
    children:[{
      path: '/details',
      name: 'details',
      component: () => import('@/views/details.vue')
    }]
  },
  {
    path: '/detailsOrder',
    component: Layout,
    redirect: '/detailsOrder',
    children:[{
      path: '/detailsOrder',
      name: 'detailsOrder',
      component: () => import('@/views/detailsOrder.vue')
    }]
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
